import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getLastDaysCampaigns = async (selectedDomain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'campaigns/last-days',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        domain: selectedDomain,
        isEncrypted: true,
    });
}